(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-mm-cookie-preferences]');
    if (!link) return;
    const banner = window.privacyBanner;
    if (!banner || typeof banner.showPreferences !== 'function') return;
    event.preventDefault();
    const fallback = function () { window.location.assign(link.href); };
    try {
      Promise.resolve(banner.showPreferences()).catch(fallback);
    } catch (error) {
      fallback();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moomenn-marketplace-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-mm-tabs]')];
    if (scope.matches?.('[data-mm-tabs]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (root.dataset.mmTabsReady) return;
      const list = root.querySelector('[data-mm-tablist]');
      if (!list) return;
      const tabs = [...list.querySelectorAll('[data-mm-tab]')];
      const panels = tabs.map((tab) => root.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`));
      if (!tabs.length || panels.some((panel) => !panel)) return;
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].setAttribute('aria-labelledby', tab.id);
        });
        root.dataset.mmActiveTab = String(index);
        if (focus) {
          tabs[index].focus({preventScroll: true});
          tabs[index].scrollIntoView({block: 'nearest', inline: 'nearest', behavior: 'instant'});
        }
      };
      list.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-mm-tab]');
        const index = tabs.indexOf(tab);
        if (index >= 0) activate(index);
      });
      list.addEventListener('keydown', (event) => {
        const index = tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(next, true);
      });
      activate(0);
      root.dataset.mmTabsReady = 'true';
      list.hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), {once: true});
  else initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
